export class AvailabilityProvider {
}
export class Availabilities {
}
export var Possibility;
(function (Possibility) {
    Possibility[Possibility["Unknown"] = 0] = "Unknown";
    Possibility[Possibility["Possible"] = 1] = "Possible";
    Possibility[Possibility["NotPossible"] = 2] = "NotPossible";
})(Possibility || (Possibility = {}));
